import LanguageUtil from './LanguageUtil';
import {CustomListTabType} from '../domain/custom-list/CustomListDomains';

type ServerErrorBody = string | {message?: string | string[]; error?: string; summary?: string};

class CustomListImportErrorUtil {

  public static resolveErrorMessage(error: unknown, recordType: CustomListTabType): string {
    const axiosError = error as {
      response?: {status?: number; data?: ServerErrorBody};
      message?: string;
    };
    const serverMessage: string = this.extractServerMessage(axiosError?.response?.data);
    if (this.isIncompatibleFileMessage(serverMessage)) {
      return this.getIncompatibleFileMessage(recordType);
    }
    if (serverMessage.length > 0) {
      return serverMessage;
    }
    if (typeof axiosError?.message === 'string' && axiosError.message.trim().length > 0) {
      return axiosError.message;
    }
    return LanguageUtil.get({id: 'pages.customList.importFailed', defaultMessage: 'CSV import failed'});
  }

  private static extractServerMessage(data: ServerErrorBody | undefined): string {
    if (typeof data === 'string' && data.trim().length > 0) {
      return data;
    }
    if (data == undefined || typeof data !== 'object') {
      return '';
    }
    if (Array.isArray(data.message)) {
      return data.message.filter((item) => typeof item === 'string' && item.trim().length > 0).join(', ');
    }
    if (typeof data.message === 'string' && data.message.trim().length > 0) {
      return data.message;
    }
    if (typeof data.error === 'string' && data.error.trim().length > 0) {
      return data.error;
    }
    if (typeof data.summary === 'string' && data.summary.trim().length > 0) {
      return data.summary;
    }
    return '';
  }

  private static isIncompatibleFileMessage(message: string): boolean {
    return message.toLowerCase().includes('not suitable');
  }

  private static getIncompatibleFileMessage(recordType: CustomListTabType): string {
    switch (recordType) {
      case 'entity':
        return LanguageUtil.get({
          id: 'pages.customList.importIncompatibleEntity',
          defaultMessage: 'This file content is not suitable for Entity. Please try another file.',
        });
      case 'individual':
      default:
        return LanguageUtil.get({
          id: 'pages.customList.importIncompatibleIndividual',
          defaultMessage: 'This file content is not suitable for Individual. Please try another file.',
        });
    }
  }
}

export default CustomListImportErrorUtil;
